/**
 * A review's draft kept in this browser (`draftStorage`) so a reload does not lose it: restored from `key` when what
 * is stored passes `accept`, else built by `initial`; written again on every change until `forget` (saved or
 * discarded), which removes it.
 */

import { useEffect, useState } from 'react';

import { readJsonDraft, removeDraft, writeDraft } from './draftStorage';

export function useKeptDraft<T>(key: string, initial: () => T, accept: (value: unknown) => value is T) {
  const [draft, setDraft] = useState<T>(() => readJsonDraft(key, accept) ?? initial());
  const [kept, setKept] = useState(true);

  useEffect(() => {
    if (kept) writeDraft(key, JSON.stringify(draft));
  }, [draft, kept, key]);

  return {
    draft,
    update: (change: (d: T) => T) => setDraft(change),
    forget: () => {
      setKept(false);
      removeDraft(key);
    },
  };
}
